/**
 * kin-lipscore-cards.js — initialise Lipscore star widgets on product cards
 * that arrive after page load.
 *
 * lipscore-v1.js scans for `.lipscore-rating-small` once, on its own init.
 * Sleek re-renders the collection grid over AJAX on every filter/sort change
 * (assets/facets.js replaces #ProductGridContainer, then publishes
 * `facet-update`), and related-products / recently-viewed-products fetch
 * their cards by `?section_id=` after load. None of those widgets would ever
 * get stars without a re-scan. `lipscore.initWidgets()` is idempotent
 * (verified: already-rendered widgets keep exactly 5 stars), so a debounced
 * call whenever an uninitialised widget appears is safe.
 */
(() => {
  'use strict';

  const PENDING = '.lipscore-rating-small:not([data-ls-lipscore-product-id]):empty';
  let timer = 0;

  const scan = () => {
    timer = 0;
    const ls = window.lipscore;
    if (!ls || typeof ls.initWidgets !== 'function' || !ls.isInitialized || !ls.isInitialized()) return;
    if (document.querySelector(PENDING)) ls.initWidgets();
  };

  const schedule = () => {
    if (!timer) timer = window.setTimeout(scan, 150);
  };

  new MutationObserver((records) => {
    for (const r of records) {
      for (const n of r.addedNodes) {
        if (n.nodeType === 1 && (n.matches(PENDING) || n.querySelector(PENDING))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, schedule);
  }
})();
